import React from "react";
import { useStyles } from "./styles";

export const StatisticWidget = ({ children, ...props }) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const classes = useStyles(props);

  return (
    <div className={classes.root} ref={ref}>
      {children}
    </div>
  );
};
StatisticWidget.muiName = "StatisticWidget";
StatisticWidget.displayName = "StatisticWidget";

export default StatisticWidget;

export * from "./StatisticWidgetDate";
export * from "./StatisticWidgetSource";
export * from "./shared/StatisticWidgetHeader";
export * from "./shared/StatisticWidgetTable";
